// chartMixin.js
import * as d3 from 'd3';

export default {
    computed: {
        chartData() {
            let parsedData = this.data;

            if (typeof this.data === 'string') {
                parsedData = JSON.parse(this.data);
            }

            if (Array.isArray(parsedData) && parsedData.length > 0 && Array.isArray(parsedData[0])) {
                return parsedData[0];
            }

            return parsedData;
        },
        chartContainerClass() {
            return `chart--container chart--container-${ this.type }`;
        },
        chartContainerClassContent() {
            return `chart--container-${ this.type }-content`;
        },
        legendClass() {
            return `chart--legend chart--legend-${ this.type }`;
        },
    },
    methods: {
        setupSVG(width, height) {
            return d3.select(this.$refs.chart)
                .insert('svg', '.chart--legend')
                .attr('width', width)
                .attr('height', height);
        },
        setupXScale(domain, range, padding = 0) {
            return d3.scaleBand()
                .domain(domain)
                .range(range)
                .padding(padding);
        },
        setupYScale(domain, range) {
            return d3.scaleLinear()
                .domain(domain)
                .range(range);
        },
        findSegment(name, type) {
            return this.chartData.find(d => d.name === name && d.type === type);
        },
    },
};
